import { useEffect } from "react";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { changeUserEmailThunk, changeUserPasswordThunk } from "../../../store/features/auth/authSlice";
import { showNotification } from "../../../store/features/notifications/notificationSlice";
import classes from "./styles.module.scss";
import { MainButton } from '../../../components/MainButton';
import InputField from "../../../components/InputField";

export const AccountSettingsPage = () => {

  const user = useAppSelector((state) => state.auth.user);

  const dispatch = useAppDispatch();

  const [email, setEmail] = useState(user?.email || "");
  const [password, setPassword] = useState("");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("")
  const [currentPassword, setCurrentPassword] = useState("");

  const [emailError, setEmailError] = useState<string | null>(null);
  const [passwordError, setPasswordError] = useState<string | null>(null);
  const [newPasswordError, setNewPasswordError] = useState<string | null>(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState<string | null>(null);
  const [currentPasswordError, setCurrentPasswordError] = useState<string | null>(null);

  const handleSubmitEmailChange = (e: React.FormEvent) => {
    e.preventDefault();
    if (emailError || passwordError) {
      return;
    }
    dispatch(changeUserEmailThunk({ new_email: email, password }))
      .unwrap()
      .then(() => {
        dispatch(showNotification({ message: "Email changed sccesfully.", type: "success" }));
      })
      .catch(() => {
        dispatch(showNotification({ message: "Failed to change the email.", type: "error" }));
      });
  };

  const handleSubmitPasswordChange = (e: React.FormEvent) => {
    e.preventDefault();
    if (newPasswordError || confirmPasswordError || currentPasswordError) {
      return;
    }
    if (confirmPassword == newPassword) {
      dispatch(changeUserPasswordThunk({ new_password: newPassword, current_password: currentPassword }))
        .unwrap()
        .then(() => {
          dispatch(showNotification({ message: "Password changed sccesfully.", type: "success" }));
        })
        .catch(() => {
          dispatch(showNotification({ message: "Failed to change the password.", type: "error" }));
        });
    } else {
      dispatch(showNotification({ message: "Passwords do not match, try again.", type: "error" }));
    }
  };

  useEffect(() => {
    if (user?.email) {
      setEmail(user.email);
    }
  }, [user?.email]);

  return (
    <div className={classes.AccountSettingsPage}>
      <div className={classes.contentWrapper}>
        <div className={classes.infoWrapper}>
          <h2>Account Settings</h2>
          <div className={classes.infoText}>
            <p>Manage your account email address and password settings</p>
          </div>
        </div>
        <div className={classes.formWrapper}>
          <InputField label='Email' role='email' value={email} onChange={(e) => setEmail(e.target.value)} onValidationError={setEmailError} />
          <InputField label='Password' type="password" role='password' value={password} onChange={(e) => setPassword(e.target.value)} onValidationError={setPasswordError} />
          <MainButton title='Change Email' variant='primary' onClick={handleSubmitEmailChange} disabled={!email || !password || !!emailError || !!passwordError} />
        </div>
        <div className={classes.midLine}></div>
        <div className={classes.formWrapper}>
          <InputField label='New password' type="password" role='password' value={newPassword} onChange={(e) => setNewPassword(e.target.value)} onValidationError={setNewPasswordError} />
          <InputField label='Confirm new password' type="password" role='password' value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} onValidationError={setConfirmPasswordError} />
          <InputField label='Current password' type="password" role='password' value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} onValidationError={setCurrentPasswordError} />
          <MainButton title='Change password' variant='primary' onClick={handleSubmitPasswordChange} disabled={!newPassword || !confirmPassword || !currentPassword || newPassword !== confirmPassword || !!newPasswordError || !!confirmPasswordError || !!currentPasswordError} />
        </div>
      </div>
    </div>
  )
}

export default AccountSettingsPage